module.exports = __webpack_public_path__ + "static/media/blog_grid_1.07df75e7.jpg";